export const AppLogo = require("./mainLogo.png");
export const logoVideo = require("./video.mp4");
export const PatientImage = require("./patient.png");
export const CuriousImage = require("./curious.png");
export const CareGiverImage = require("./careGiver.png");
export const MentalImage = require("./mental.png");
export const NutritionImage = require("./nutrition.png");
export const PhysicalImage = require("./physical.png");
export const ImageOne = require("./1.png");
export const ImageTwo = require("./2.png");
export const Tt = require("./tt.png");
export const ImageThree = require("./3.png");
export const ImageFour = require("./4.png");
export const ImageFive = require("./5.png");
export const ImageSix = require("./6.png");
export const ImageSeven = require("./7.png");
export const ImageEight = require("./8.png");
export const ImageNine = require("./9.png");
export const ImageTen = require("./10.png");
export const ImageEleven = require("./11.png");
export const ImageTwelve = require("./12.png");
export const ImageThirteen = require("./13.png");
export const ImageFourteen = require("./14.png");
export const ImageFifteen = require("./15.png");
export const ImageSixteen = require("./16.png");
export const ImageSeventeen = require("./17.png");
export const ImageEighteen = require("./18.png");
export const ImageNineteen = require("./19.png");
export const ImageTwenty = require("./20.png");
export const ImageTwentyOne = require("./21.png");
export const ImageTwentyTwo = require("./22.png");
export const ImageTwentyThree = require("./23.png");
export const ImageTwentyFour = require("./24.png");
export const ImageTwentyFive = require("./25.png");
export const ImageTwentySix = require("./26.png");
export const ImageTwentySeven = require("./27.png");
export const ImageTwentyEight = require("./28.png");
export const ImageTwentyNine = require("./29.png");
export const ImageThirty = require("./30.png");
export const ImageThirtyOne = require("./31.png");
export const ImageThirtyTwo = require("./32.png");
export const ImageThirtyThree = require("./33.png");
export const ImageThirtyFour = require("./34.png");
export const ImageThirtyFive = require("./35.png");
export const ImageThirtySix = require("./36.png");
export const PhoneImage = require("./phone.png");
export const AvtarImage = require("./avatar.png");
export const ImageThirtyEight = require("./38.png");
export const ImageThirtyNine = require("./39.png");
export const ImageForty = require("./40.png");
export const ImageFortyOne = require("./41.png");
export const ImageFortyTwo = require("./42.png");
export const ImageFortyThree = require("./43.png");
export const ImageFortyFour = require("./44.png");
export const ImageFortyFive = require("./45.png");
export const ImageFortySix = require("./46.png");
export const ImageFortySeven = require("./47.png");
export const ImageFortyEight = require("./48.png");
export const ImageFortyNine = require("./49.png");
export const ImageFifty = require("./50.png");
export const ImageFiftyOne = require("./51.png");
export const ImageFiftyTwo = require("./52.png");
export const ImageFiftyThree = require("./53.png");
export const ImageFiftyFour = require("./54.png");
export const ImageFiftyFive = require("./55.png");
export const ImageFiftySix = require("./56.png");
export const ImageShieldPink = require("./shieldPink.png");
export const QrScanner = require("./qrScanner.png");
export const AppleLogo = require("./appleLogo.png");

